import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
export interface NavigationCard {
  title: string;
  description: string;
  icon?: string;
  route: string;
  color?: string;
}

@Component({
  selector: 'app-lt-navigation-card',
  imports: [CommonModule, RouterModule],
  template: `
    <a [routerLink]="[ card().route ]" class="card-link-overlay">
      <div class="col h-100 navigation-card no-decoration mb-4" [ngClass]="card().color">
          <div class="card no-decoration">
              <div class="card-header bg-secondary text-white no-decoration">
                <div class="d-flex align-items-center">
                  @if(card().icon) {
                    <div class="card-icon me-3">
                      <i [class]="card().icon" class="fs-2"></i>
                    </div>
                  }
                  <h5 class="card-title mb-0 fw-semibold">{{ card().title }}</h5>
                </div>
              </div>
              <div class="card-body">
                <p class="card-text text-muted mb-0">{{ card().description }}</p>
              </div>
          </div>
      </div>
    </a>
  `,
  styles: `
    .no-decoration {
      text-decoration: none;
    }

    .navigation-card {
      transition: all 0.3s ease;
      border: none;
      box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.1);
      overflow: hidden;
      text-decoration: none;

      &:hover {
        transform: translateY(-0.25rem);
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
      }

      &.primary {
        .card-header .card-icon i { color: var(--bs-primary); }
      }

      &.success {
        .card-header .card-icon i { color: var(--bs-success); }
      }

      &.info {
        .card-header .card-icon i { color: var(--bs-info); }
      }

      &.warning {
        .card-header .card-icon i { color: var(--bs-warning); }
      }

      .card-header {
        border-bottom: none;
        
        .card-title {
          color: white;
        }
        
        .card-icon i {
          color: white;
        }
        
        .card-arrow {
          transition: transform 0.3s ease;
          color: rgba(255, 255, 255, 0.8);
        }
      }

      &:hover .card-header .card-arrow {
        transform: translateX(0.25rem);
      }

      .card-body {
        background-color: var(--bs-light);
        min-height: 80px;
        display: flex;
        align-items: center;
      }
    }

    .card-link-overlay {
      text-decoration: none;
      color: inherit;
      display: block;
      position: relative;

      &:hover {
        text-decoration: none;
        color: inherit;
      }

      &:focus {
        outline: 2px solid var(--bs-primary);
        outline-offset: 2px;
        border-radius: 0.375rem;
      }

      &::after {
        content: 'Ctrl+click or right-click for new tab';
        position: absolute;
        bottom: 0.5rem;
        right: 0.75rem;
        font-size: 0.7rem;
        color: var(--bs-secondary);
        opacity: 0;
        transition: opacity 0.3s ease;
        pointer-events: none;
      }

      &:hover::after {
        opacity: 1;
      }
    }
  `,
  standalone: true,
})
export class LTNavigationCardComponent {
  card = input.required<NavigationCard>();

  constructor(private router: Router) {}
}
